import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, Box, Typography, TextField, Button, InputLabel, MenuItem, FormControl } from "@material-ui/core";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import ReplayIcon from "@material-ui/icons/Replay";
import { Alert, AlertTitle } from "@material-ui/lab";
import { ApplicationDataAPI } from '../../API/ApplicationDataAPI';

const reasoncategories = [
  "Deal did not close",
  "Deal closed with other lender",
];
const reasonList1 = [
  "Customer not moving forward at this time",
  "Customer choose different asset",
  "Rate too high",
  "Down Payment too high",
  "Customer wants a loan vs. a lease(must be lease with nmef)",
  "Customer paid cash",
  "Open stips not satisfied",
  "Other (Please fill in)",
];
const reasonList2 = [
  "Lender had better rate",
  "Lender had lower down payment",
  "Lender did not have as many stips",
  "Lender offered loan vs. lease",
  "Lender had fewer up front fees",
  "Lender had better service",
  "Lender paid higher commission",
  "Other (Please fill in)",
];

const useStyles = makeStyles({
  container: {
    width: "720px",
    margin: "1rem auto",
  },
  table: {
    minWidth: 500,
    "& th": {
      width: "125px",
      fontWeight: 600,
      border: "none",
    },
    "& td": {
      border: "none",
    },
  },
  inputLabel: {
    display: "none",
  },
  unRejectButton: {
    borderColor: "#d47500",
    backgroundColor: "#d47500",
    marginRight: "1rem",
    color: "white",
  },
  border: {
    borderBottom: "1px solid    rgba(224, 224, 224, 1)",
  },
  paper: {
    padding: "20px 10px",
  },
  selectContainer: {
    height: "35px"
  }
});

const initialDecision = {
  type: "Cancel",
  categoty: "",
  reason: "",
  otherReason: "",
  note: "",
};

export default function Cencel({ app, handleClose }) {
  const classes = useStyles();
  const [application, setApplication] = useState({});
  const [decision, setDecision] = useState(initialDecision);
  const [reasonList, setReasonList] = useState([]);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({ status: false, message: "" });
  const [decline, setDecline] = useState(false);

  useEffect(() => {
    (async () => {
      if (app) {
        try {
          const response = await ApplicationDataAPI.fetchApplicationById(app.id, "ALL", app.locked_by_email);
          console.log("camcel", app.locked_by_email)
          setApplication(response);
        } catch (err) {
          setError({ status: true, message: err.message });
        } finally {
          setLoading(false);
        }
      }
    })();
  }, [app]);

  useEffect(() => {
    if (application)
      setDecline(
        application.application_state === "Open" ||
          application.application_state === "Expired"
          ? false
          : true
      );
  }, [application]);

  const handleReasonCategory = (event) => {
    const selectedCategory = event.target.value;
    setDecision({ ...decision, categoty: selectedCategory });
    if (selectedCategory === "Deal did not close") setReasonList(reasonList1);
    else if (selectedCategory === "Deal closed with other lender")
      setReasonList(reasonList2);
    else setReasonList([]);
  };

  const handleReason = (event) => {
    setDecision({ ...decision, reason: event.target.value });
  };

  const handleRejection = async () => {
    try {
      setSaving(true);
      const updateApp = {
        ...application,
        application_state: "Canceled",
        cancel_category: decision.categoty,
        cancel_reason: decision.reason,
        cancel_other_reason: decision.otherReason,
        decline_reason_notes: decision.note,
      };

      await ApplicationDataAPI.updateApplicationWithAction(
        updateApp, { action: "reject" }, "ALL", app.locked_by_email
      );
      setDecision(initialDecision);
      const response = await ApplicationDataAPI.fetchApplicationById(app.id, "ALL", app.locked_by_email);
      setApplication(response);
      if (window.updateApplicationsList)
        window.updateApplicationsList(response);
    } catch (err) {
      setError({
        status: true,
        message: "Data couldn't updated properly! " + err.message,
      });
    } finally {
      setSaving(false);
    }
  };

  const handleUnRejection = async () => {
    try {
      setSaving(true);
      const updateApp = {
        ...application,
        application_state: "Open",
        cancel_category: "",
        cancel_reason: "",
        cancel_other_reason: "",
        decline_reason_notes: "",
      };
      await ApplicationDataAPI.updateApplication(updateApp, "ALL", app.locked_by_email);
      const response = await ApplicationDataAPI.fetchApplicationById(app?.id, "ALL", app.locked_by_email);
      setApplication(response);
      if (window.updateApplicationsList)
        window.updateApplicationsList(response);
    } catch (err) {
      setError({
        status: true,
        message: "Data couldn't updated properly! " + err.message,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box className={classes.container}>
      {loading && (
        <Box style={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      )}

      {!loading && saving && (
        <Box style={{ textAlign: "center" }}>
          <Typography variant="subtitle2" style={{ marginBottom: "1rem" }}>
            Please Wait, your request is being processed...
          </Typography>
          <LinearProgress />
        </Box>
      )}

      {!loading && !saving && error.status && (
        <Box>
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            {error.message}
          </Alert>
        </Box>
      )}

      {!loading && !saving && !error.status && (
        <TableContainer component={Paper} className={classes.paper} elevation={0}>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableBody>
              {!decline && (
                <>
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      align="right"
                      style={{ paddingTop: "15px", paddingBottom: "15px" }}
                    >
                      Decision Type:
                    </TableCell>
                    <TableCell align="left">{decision.type}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row" align="right">
                      Reason Category:
                    </TableCell>
                    <TableCell align="left">
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        fullWidth
                        size="small"
                      >
                        <InputLabel
                          id="category-select-label"
                          classes={{
                            shrink: classes.inputLabel,
                          }}
                        >
                          Select Category
                        </InputLabel>
                        <Select
                          labelId="category-select-label"
                          id="category-select"
                          value={decision.categoty}
                          className={classes.selectContainer}
                          onChange={handleReasonCategory}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {reasoncategories.map((item, index) => (
                            <MenuItem key={index} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row" align="right">
                      Reason:
                    </TableCell>
                    <TableCell align="left">
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        fullWidth
                        size="small"
                      >
                        <InputLabel
                          id="reason-select-label"
                          classes={{
                            shrink: classes.inputLabel,
                          }}
                        >
                          Select Reason
                        </InputLabel>
                        <Select
                          labelId="reason-select-label"
                          id="reason-select"
                          className={classes.selectContainer}
                          value={decision.reason}
                          onChange={handleReason}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {reasonList.map((item, index) => (
                            <MenuItem key={index} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  {decision.reason === "Other (Please fill in)" && (
                    <TableRow>
                      <TableCell component="th" scope="row" align="right">
                        Other Reason:
                      </TableCell>
                      <TableCell align="left">
                        <TextField
                          fullWidth
                          variant="outlined"
                          multiline
                          maxRows={4}
                          value={decision.otherReason}
                          onChange={(e) =>
                            setDecision({
                              ...decision,
                              otherReason: e.target.value,
                            })
                          }
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell component="th" scope="row" align="right">
                      Note:
                    </TableCell>
                    <TableCell align="left">
                      <TextField
                        fullWidth
                        variant="outlined"
                        multiline
                        maxRows={4}
                        value={decision.note}
                        onChange={(e) =>
                          setDecision({ ...decision, note: e.target.value })
                        }
                      />
                    </TableCell>
                  </TableRow>
                </>
              )}

              {decline && (
                <>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell
                      align="left"
                      className={classes.border}
                    >
                      <Typography variant="subtitle1" gutterBottom>
                        This application is{" "}
                        <span style={{ fontWeight: 600 }}>
                          {application.application_state}
                        </span>
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row" align="right">
                      Reason Category:
                    </TableCell>
                    <TableCell align="left">
                      {application.cancel_category}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row" align="right">
                      Reason:
                    </TableCell>
                    <TableCell align="left">
                      {application.cancel_reason}
                    </TableCell>
                  </TableRow>
                  {application.cancel_other_reason !== undefined &&
                    application.cancel_other_reason !== "" && (
                      <TableRow>
                        <TableCell component="th" scope="row" align="right">
                          Other Reason:
                        </TableCell>
                        <TableCell align="left">
                          {application.cancel_other_reason}
                        </TableCell>
                      </TableRow>
                    )}
                  <TableRow>
                    <TableCell component="th" scope="row" align="right">
                      Note:
                    </TableCell>
                    <TableCell align="left">
                      {application.decline_reason_notes}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell component="th" scope="row" align="right">
                      User:
                    </TableCell>
                    <TableCell align="left">
                      {application.declined_by}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row" align="right">
                      Date:
                    </TableCell>
                    <TableCell align="left">
                      {moment(application.declined_date).format("MM/DD/YYYY h:mm A")}
                    </TableCell>
                  </TableRow>
                </>
              )}

              <TableRow>
                <TableCell
                  colSpan={2}
                  align="center"
                  style={{ paddingTop: "16px" }}
                >
                  {!decline && (
                    <Button
                      variant="contained"
                      color="primary"
                      disableElevation
                      disabled={
                        decision.categoty === "" ||
                        decision.reason === "" ||
                        (decision.reason === "Other (Please fill in)" &&
                          decision.otherReason === "") ||
                        decision.note === ""
                      }
                      onClick={handleRejection}
                      style={{ marginRight: "1rem" }}
                    >
                      Apply
                    </Button>
                  )}

                  {decline && (
                    <Button
                      disabled={saving}
                      variant="contained"
                      disableElevation
                      className={classes.unRejectButton}
                      startIcon={
                        saving ? <CircularProgress size={20} /> : <ReplayIcon />
                      }
                      onClick={() => handleUnRejection()}
                    >
                      Un-Reject
                    </Button>
                  )}

                  <Button
                    variant="contained"
                    color="secondary"
                    disableElevation
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
